<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmh1"><a href="#/SeducedByARogu_toc#fore-1"><em>Author’s Note</em></a></h1>
<p class="p1"><span class="dropcap">F</span>or the reader’s convenience, the author offers the following aids:
      </p>
<p>Caerlaverock = Car LAV rock</p>
<p>Dunwythie Hall = “the Hall,” the fortified house at Dunwythie Mains</p>
<p>Ebb tide = falling or receding tide</p>
<p>Flood tide = incoming or rising tide</p>
<p>Forbye = besides, also</p>
<p>“Herself” = in this book, Arabella Carlyle (née Bruce), Lady Kelso</p>
<p>Kirkcudbright = Kirk COO bree</p>
<p>Low tide (or low water) = lowest point of the ebb</p>
<p>Mains = the primary seat of a lord (from “demesne”), as in Dunwythie Mains</p>
<p>Neap tide = minimum tide, tide of minimum rise, when rise and fall show least change; occurs generally during first and third
         quarters of the moon
      </p>
<p>Nithsdale = NEETHS dale</p>
<p>Spring tide = tide occurring at or shortly after the new or full moon; tide of maximum rise, occurs twice a month</p>
<p>Stem up = begin to flood (at Annan, about three hours before high water; at Kirkcudbright Bay, about five hours before)</p>
<p>Thole = busy</p>
<p>Tocher = Scottish term for dowry</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SeducedByARogu_fore-1.vue?0e99ceda